import { Flex, IconButton as IconButtonUI } from "@evergis/ui";
import styled from "styled-components";

export const Title = styled("div")`
  opacity: 0.87;
  font-size: 1rem;
  margin-top: 0.5rem;
`;

export const TitleExample = styled("div")`
  opacity: 0.87;
  font-size: 0.75rem;
  letter-spacing: 0.1px;
  margin-left: 2rem;
`;

export const IconButton = styled(IconButtonUI)<{ margin?: string }>`
  margin-top: ${({ margin }) => margin};
  transform: ${({ kind }) => kind === "pause" && "rotate(90deg)"};
`;

export const ExampleContainer = styled(Flex)`
  justify-content: space-between;
  margin: 0 4.5rem 1.5rem 4.5rem;
`;

export const Container = styled("div")`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  background-color: rgba(0, 0, 0, 0.06);
  border: solid 1px rgba(0, 0, 0, 0.12);
  margin-bottom: 2.5rem;
`;

export const ImageExample = styled.div<{ img: string }>`
  display: flex;
  padding-top: 0;
  background: ${({ img }) => `url(${img}) center center no-repeat`};
  height: 7rem;
  width: 7rem;
`;

export const TitleContainer = styled(Flex)`
  cursor: pointer;
  outline: none;
  user-select: none;
  margin-right: auto;
  padding-right: 1rem;
`;

export const Column = styled("div")`
  display: flex;
  flex-direction: column;
  padding-top: 1.5rem;
`;

export const ImageLabel = styled("div")`
  width: 7rem;
  opacity: 0.75;
  font-size: 10px;
  letter-spacing: 0.08px;
  text-align: center;
`;
